// extracted by mini-css-extract-plugin
export default {"rating":"BP-z","numberOfStars":"CP-z","count":"DP-z","barGraphSpacing":"EP-z","barGraph":"FP-z"};